import * as React from 'react'
import * as Device from '../service/device'


export default class AboutModal extends React.PureComponent<{
  onClose: () => void
}> {

  render() {
    const { onClose } = this.props

    return (
      <div className="modal about-modal">
        <div className="modal-content">

          <h1>About</h1>

          <p style={{textAlign: 'center'}}><strong>Type anything to get started.<br/>Tap on a name you like to buy it or save it for later.</strong></p>

          <p>NameQL helps you find a great name. It considers thousands of potential names in milliseconds and shows you the best, and only the ones where [name].com is available.</p>

          {Device.IS_DESKTOP &&
            <p><strong>Pro Tip: </strong>Press <strong>up</strong> to go back, and <strong>down</strong> or <strong>enter</strong> to get more results.</p>
          }

          <button className="modal-close" onClick={onClose}>&times;</button>

        </div>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/comp/about-modal.tsx